import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  listItem: {
    opacity: 0.8,
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.main,
    height: theme.spacing(11),
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginBottom: theme.spacing(2),
    backgroundOrigin: "border-box",
    border: "1px dashed transparent !important",
  },
  firstItem: {
    borderTop: `1px dashed ${theme.palette.secondary.tint40} !important`,
    borderTopLeftRadius: [theme.spacing(2), "!important"],
    borderTopRightRadius: [theme.spacing(2), "!important"],
  },
  lastItem: {
    borderBottom: `1px dashed ${theme.palette.secondary.tint40} !important`,
    borderBottomLeftRadius: [theme.spacing(2), "!important"],
    borderBottomRightRadius: [theme.spacing(2), "!important"],
  },
  test: {
    borderRight: `1px dashed ${theme.palette.secondary.tint40} !important`,
    borderLeft: `1px dashed ${theme.palette.secondary.tint40} !important`,
    borderBottomLeftRadius: [theme.spacing(2), "!important"],
    borderBottomRightRadius: [theme.spacing(2), "!important"],
    width: "100.7%",
    marginLeft: "-1px",
  },
  listItemSell: {
    background: [theme.palette.red2.tint35, "!important"],
  },
  listItemBuy: {
    background: [theme.palette.primary.tint35, "!important"],
  },
  listSellSize: {
    backgroundImage: (props) =>
      `linear-gradient(to right, ${theme.palette.background.main} ${
        100 - props.percent
      }%, ${
        theme.palette.type === "light"
          ? theme.palette.red2.tint35
          : theme.palette.red2.main
      } ${100 - props.percent}%)`,
  },
  listBuySize: {
    backgroundImage: (props) =>
      `linear-gradient(${props.gradientSide}, ${
        theme.palette.background.main
      } ${100 - props.percent}%, ${
        theme.palette.type === "light"
          ? theme.palette.primary.tint35
          : theme.palette.primary.main
      } ${100 - props.percent}%)`,
  },

  isMyOrder: {
    backgroundColor: [theme.palette.yellow.tint60, "!important"],
  },
  block: {
    borderRight: `1px solid ${theme.palette.background.main}`,
    height: "90%",
  },
}));
